import { useState, useEffect } from 'react';
import { CreditCard, Check, X, AlertCircle } from 'lucide-react';
import { subscriptionAPI } from '../services/api';
import { useHaptic } from '../hooks/useHaptic';
import './SavedCardPage.css';

function SavedCardPage() {
  const haptic = useHaptic();
  const [savedCard, setSavedCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unlinkingCard, setUnlinkingCard] = useState(false);

  useEffect(() => {
    const fetchSavedCard = async () => {
      try {
        const response = await subscriptionAPI.getSavedCard();
        setSavedCard(response.data.savedCard);
      } catch (error) {
        console.error('Ошибка загрузки привязанной карты:', error);
        setSavedCard(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedCard();
  }, []);

  // Получение названия типа карты
  const getCardTypeName = (cardType) => {
    const types = {
      'Visa': 'Visa',
      'MasterCard': 'Mastercard',
      'Mastercard': 'Mastercard',
      'Mir': 'Мир',
      'MIR': 'Мир',
    };
    return types[cardType] || cardType || 'Карта';
  };

  // Отвязка карты
  const handleUnlinkCard = async () => {
    if (!confirm('Вы уверены, что хотите отвязать карту? Автоматическое продление подписки будет отключено.')) {
      return;
    }

    haptic.buttonPressImportant();
    setUnlinkingCard(true);

    try {
      await subscriptionAPI.unlinkCard();
      setSavedCard(null);
      alert('Карта успешно отвязана. Автопродление отключено.');
    } catch (error) {
      console.error('Ошибка отвязки карты:', error);
      alert('Ошибка при отвязке карты. Попробуйте позже.');
    } finally {
      setUnlinkingCard(false);
    }
  };

  if (loading) {
    return (
      <div className="saved-card-page">
        <div className="saved-card-container">
          <div className="loading-state">
            <span className="loader"></span>
            <p>Загрузка...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="saved-card-page">
      <div className="saved-card-container">
        <h1 className="page-title">Способы оплаты</h1>
        <p className="page-subtitle">
          Управление привязанными картами для автоматического продления подписки
        </p>

        {savedCard ? (
          <div className="card-section">
            <h2 className="section-title">Привязанная карта</h2>
            
            <div className="card-block">
              <div className="card-visual">
                <div className="card-icon">
                  <CreditCard size={36} />
                </div>
                <div className="card-details">
                  <span className="card-type">{getCardTypeName(savedCard.cardType)}</span>
                  <span className="card-number">•••• •••• •••• {savedCard.cardLast4}</span>
                </div>
              </div>

              <div className="card-status">
                <div className="status-badge active">
                  <Check size={16} />
                  <span>Автопродление включено</span>
                </div>
                <p className="status-description">
                  Подписка будет автоматически продлеваться с этой карты
                </p>
              </div>

              <button
                className="unlink-button"
                onClick={handleUnlinkCard}
                disabled={unlinkingCard}
              >
                {unlinkingCard ? (
                  <span className="loader-small"></span>
                ) : (
                  <>
                    <X size={18} />
                    <span>Отвязать карту</span>
                  </>
                )}
              </button>
            </div>

            <div className="info-block">
              <AlertCircle size={18} />
              <p>
                При отвязке карты автоматическое продление подписки будет отключено. 
                Вам потребуется оплачивать подписку вручную после окончания текущего периода.
              </p>
            </div>
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">
              <CreditCard size={48} />
            </div>
            <h3>Нет привязанных карт</h3>
            <p>
              Привяжите карту при оплате подписки, чтобы включить автоматическое продление.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SavedCardPage;
